import React, { useContext, useEffect, useState } from "react";
import Breadcrumb from "../components/breadCrumb";
import NoRequest from "../components/case-overview/no-requests";
import LargeTitle from "../components/case-tracking/LargeTitle";
import { PhrasesContext } from "../context/phrasesContext";
import ThemeLayout from "../layouts/ThemeLayout";
import { getPendingPaymentServices } from "../services/Common";
import { Link, useNavigate } from "react-router-dom";

const Invoices = () => {
  const [lang, setLang] = useState("");
  const navigate = useNavigate();
  const [enPhrase, arPhrase] = useContext(PhrasesContext);
  const [apiData, setApiData] = useState({
    loading: true,
    data: [],
    error: false,
  });
  const [pendingPaymentServices, setPendingPaymentServices] = useState([]);

  useEffect(() => {
    const lang = window.localStorage.getItem("lang");
    let currentLang = lang;
    if (lang === "en") {
      document.body.dir = "ltr";
      setLang("en");
      currentLang = "en";
    } else {
      document.body.dir = "rtl";
      setLang("ar");
      currentLang = "ar";
    }
    getDetails(currentLang);
  }, []);

  const getDetails = (currentLang) => {
    setApiData({ loading: true, data: [], error: false });

    return getPendingPaymentServices(currentLang)
      .then((res) => {
        console.log("Pending Payment API Response:", res);

        const list = Array.isArray(res)
          ? res
          : Array.isArray(res?.services)
            ? res.services
            : Array.isArray(res?.data)
              ? res.data
              : Array.isArray(res?.result)
                ? res.result
                : Array.isArray(res?.items)
                  ? res.items
                  : [];

        console.log("Final services list:", list);

        setApiData({
          loading: false,
          data: list,
          error: false,
        });

        setPendingPaymentServices(list);
      })
      .catch((error) => {
        console.error("Pending Payment Error:", error);

        setApiData({
          loading: false,
          data: [],
          error: true,
        });

        setPendingPaymentServices([]);
      });
  };

  //   const handleFilteredArchives = (value) => {
  //     const filterd = apiData?.data?.filter((el) =>
  //       el?.caseNumber?.includes(value),
  //     );
  //     setFilteredArchives(filterd);
  //   };

  console.log("apiData", apiData);
  console.log("pendingPaymentServices", pendingPaymentServices);

  return (
    <ThemeLayout>
      <div className="flex flex-col w-full py-4 px-[24px] lg:px-0">
        {!apiData?.loading ? (
          Array.isArray(apiData?.data) && apiData.data.length > 0 ? (
            <>
              <Breadcrumb
                title={
                  lang === "en"
                    ? enPhrase["lblFollowCases"]
                    : arPhrase["lblFollowCases"]
                }
                last={
                  lang === "en"
                    ? enPhrase["lblInvoices"]
                    : arPhrase["lblInvoices"]
                }
              />
              <div className="flex flex-col gap-[8px]">
                <div className="flex flex-row items-center gap-4 ">
                  <LargeTitle
                    title={
                      lang === "en"
                        ? enPhrase["lblListInvoices"]
                        : arPhrase["lblListInvoices"]
                    }
                    nullmargin
                  />
                  <div className="flex items-center gap-[4px] border !border-[#F2C99B] rounded-[16px] py-[4px] px-[8px]">
                    <img
                      src="/assets/img/invoices/Rectangle.svg"
                      alt=""
                      className="w-[9px] h-[9px]"
                    />
                    <span className="text-[12px] md:text-[14px] text-[#6F6A62] font-Almarai  font-bold leading-[16px] md:leading-[24px]">
                      {lang === "en"
                        ? enPhrase["lblPendingPayment"]
                        : arPhrase["lblPendingPayment"]}
                    </span>
                  </div>
                </div>
                <span className="text-[12px] text-[#8D867D] font-Almarai  font-[400] leading-[16px] md:leading-[24px]">
                  {lang === "en"
                    ? enPhrase["lblListInvoicesText"]
                    : arPhrase["lblListInvoicesText"]}
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-[16px] w-full mt-[8px]">
                {pendingPaymentServices.map((service, index) => (
                  <div
                    key={index}
                    className="flex flex-col border !border-[#E6D7A2] rounded-[8px] pt-[16px] gap-[16px] bg-[#FFFFFF] "
                  >
                    <div className="flex flex-row items-center justify-between px-[16px]">
                      <div className="flex flex-col items-Start gap-[4px]">
                        <p className="text-[14px] text-[#8D867D] font-Almarai font-[400]">
                          {lang === "en" ? "Invoice Number:" : " فاتوره رقم:"}
                        </p>
                        <span className="text-[14px] text-[#0E0D0C] font-Almarai font-[700] leading-[26px]">
                          {service?.invoiceNumber}
                        </span>
                      </div>
                      <div className="flex flex-row items-center border border-[#3E3B37] bg-[#3E3B37] py-[4px] px-[10px] rounded-[40px] gap-[4px]">
                        <img
                          src="/assets/img/invoices/FileText.svg"
                          alt=""
                          className=""
                        />
                        <div className="flex flex-row items-center gap-[4px]">
                          <span className="text-[12px] text-[#fff] font-Almarai font-[400]">
                            {service?.totalServices}
                          </span>
                          <p className="text-[12px] text-[#fff] font-Almarai font-[400]">
                            {lang === "en"
                              ? service?.totalServices === 1
                                ? "Request"
                                : "Requests"
                              : service?.totalServices === 1
                                ? "طلب"
                                : "طلبات"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="border border-[#A3A3A340] !px-[16px]"></div>

                    <div className="flex flex-col items-start justify-between gap-[8px] px-[16px]">
                      <div className="flex flex-col items-start gap-[4px]">
                        <p className="text-[14px] text-[#8D867D] font-Almarai font-[400]">
                          {lang === "en"
                            ? enPhrase["lblCaseNumber"]
                            : arPhrase["lblCaseNumber"]}
                        </p>
                        <span className="text-[14px] text-[#0E0D0C] font-Almarai font-[700] leading-[26px]">
                          {service?.caseNumber || 0}
                        </span>
                      </div>
                      <div className="flex flex-row items-center border !border-[#E6E6E6] bg-[#F7F7F7] py-[4px] px-[8px] rounded-[8px] gap-[4px]">
                        <img
                          src="/assets/img/invoices/Court.svg"
                          alt=""
                          className="w-[16px] h-[16px]"
                        />

                        <p className="text-[14px] text-[#6F6A62] font-Almarai font-[400] leading-[16px] md:leading-[24px]">
                          {service?.courtName}
                        </p>
                      </div>
                    </div>

                    <div className="flex flex-col gap-[8px] bg-[#E6D7A24D] py-[12px] px-[16px]">
                      <div className="mb-[8px] flex items-center justify-between">
                        <p className="text-[14px] text-[#8D867D] font-[400] font-Almarai leading-[24px]">
                          {" "}
                          {lang === "en"
                            ? enPhrase["lblClaimedValueTotal"]
                            : arPhrase["lblClaimedValueTotal"]}
                        </p>
                        <div
                          className={`flex ${
                            lang === "en" ? "flex-row-reverse" : ""
                          }  gap-[3px] items-center justify-center`}
                        >
                          <p className="text-[18px] text-[#A98031] font-Almarai font-bold">
                            {/* {USDollar.format(service?.serviceValue)} */}
                            {service?.totalServiceValue}
                          </p>
                          <span className="text-muted small text-decoration-line-through !text-[#A98031]  flex items-center h-full">
                            <span
                              className="uae-symbol text-[18px] !text-[#A98031] !leading-[28px] md:font-bold"
                              lang="en"
                              dir="ltr"
                            >
                              &#x00EA;
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className="border !border-[#B68A3540]"></div>

                      <div className="mb-[8px] flex items-center justify-between">
                        <p className="text-[14px] text-[#B68A35] font-[400] font-Almarai leading-[24px]">
                          {" "}
                          {lang === "en"
                            ? enPhrase["lblViewDetailsPayment"]
                            : arPhrase["lblViewDetailsPayment"]}
                        </p>
                        <Link
                          onClick={(e) => {
                            e.preventDefault(); // Prevent default navigation
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                            localStorage.setItem("currentPage", 1); // Update state
                            navigate(`/invoice-details/${service?.invoiceId}`); // Manually navigate
                          }}
                          to={`/invoice-details/${service?.invoiceId}`}
                        >
                          <img
                            src="/assets/img/invoices/Arrow.svg"
                            alt="arrow"
                            className={`${lang === "en" ? "rotate-180" : ""}`}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <NoRequest isInvoice />
          )
        ) : (
          <p className="text-[#b68a35] font-bold font-Almarai mt-[8px]">
            {lang === "en" ? "Loading..." : "جاري عرض البيانات..."}
          </p>
        )}
      </div>
    </ThemeLayout>
  );
};

export default Invoices;
